import { HTMLProps } from "react";
import { useFitText } from "./useTextFit";

interface TextFitProps extends HTMLProps<HTMLDivElement> {
    minFontSizePx?: number;
    maxFontSizePx?: number;
    resolution?: number;
    singleLine?: boolean;
}

export function TextFit({
    children,
    minFontSizePx,
    maxFontSizePx,
    resolution,
    singleLine,
    ...props
}: Readonly<TextFitProps>) {
    const { ref } = useFitText({ minFontSizePx, maxFontSizePx, resolution, singleLine });

    return (
        <div ref={ref} {...props}>
            {children}
        </div>
    );
}
